<template>
  <q-form ref="editForm">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
        <c-card title="점검설비 상세" class="cardClassDetailForm">
          <template slot="card-button">
            <q-btn-group outline >
              <c-btn 
                v-show="editInfo&&preStartupCheck.sopPrestartupCheckId&&!disabled" 
                :isSubmit="isComplete"
                :url="completeUrl"
                :param="preStartupEquipment"
                mappingType="PUT"
                label="완료" 
                icon="check"
                @beforeAction="completePreStartupEquipment"
                @btnCallback="completeCallback" />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-xs-12 col-sm-2 col-md-2 col-lg-12">
              <c-text
                :editable="editInfo"
                :disabled="true"
                label="설비유형"
                name="equipmentTypeName"
                v-model="preStartupEquipment.equipmentTypeName">
              </c-text>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-4 col-lg-12">
              <c-multi-select
                :editable="editInfo"
                :disabled="disabled"
                :isObject="true"
                :disabledItems="disabledItems"
                codeGroupCd="PSR_CHECK_TYPE_CD"
                itemText="codeName"
                itemValue="code"
                valueText="psrCheckTypeName"
                valueKey="psrCheckTypeCd"
                label="점검유형"
                name="checkTypes"
                v-model="preStartupEquipment.checkTypes"
                @datachange="changeCheckType">
              </c-multi-select>
            </div>
            <div class="col-xs-12 col-sm-2 col-md-2 col-lg-12">
              <c-field 
                :required="true" 
                :editable="editInfo"
                :disabled="disabled"
                type="user" 
                label="설비점검책임자" 
                name="checkUserId" 
                v-model="preStartupEquipment.checkUserId" />
            </div>
            <div class="col-xs-12 col-sm-2 col-md-2 col-lg-12">
              <c-datepicker
                :editable="editInfo"
                :disabled="disabled"
                label="점검예정일"
                name="checkScheduleDate"
                v-model="preStartupEquipment.checkScheduleDate"
              />
            </div>
            <div class="col-xs-12 col-sm-2 col-md-2 col-lg-12">
              <c-datepicker
                :editable="editInfo"
                :disabled="disabled"
                label="점검일"
                name="checkDate"
                v-model="preStartupEquipment.checkDate"
              />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <c-textarea
                :editable="editInfo"
                :disabled="disabled"
                :rows="5"
                label="점검결과종합"
                name="checkResultTotal"
                v-model="preStartupEquipment.checkResultTotal">
              </c-textarea>
            </div>
          </template>
        </c-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10">
        <c-table
          ref="table"
          title="점검결과 목록"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="preStartupEquipment.checkItems"
          :merge="grid.merge"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          :editable="editInfo&&!disabled"
        >
          <!-- selection="multiple"
          rowKey="sopPrestartupCheckItemId" -->
          <!-- 버튼 영역 -->
          <!-- <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editInfo" :showLoading="false" label="추가" icon="add" @btnClicked="add" />
              <c-btn v-if="editInfo" :showLoading="false" label="제외" icon="remove" @btnClicked="remove" />
            </q-btn-group>
          </template> -->
          <template v-slot:customArea="{ props, col }">
            <div style="padding-top: 15px;">
              <q-chip
                v-for="(item, index) in props.row.improves"
                :key="index"
                :color="item.stepColorClass || 'red-6'"
                :clickable="true"
                text-color="white"
                style="margin-bottom:4px !important;"
                @click="openImprove(props, col, item)">
                <template v-if="item.ibmClassCd === 'IC00000001'">
                  {{item.sopImprovementId}} / {{item.ibmStepName}}
                </template>
                <template v-else>
                  {{item.sopImprovementId}} / 즉시조치
                </template>
              </q-chip>
              <div v-if="props.row.editFlag!=='C'">
                <q-btn-group outline class="ColumInnerBtnGroup">
                  <q-btn
                    v-if="editInfo&&!disabled"
                    icon="add"
                    color="blue-6"
                    text-color="white"
                    class="ColumInnerBtn"
                    align="center"
                    @click.prevent="innerBtnClicked(col, props)">
                    <q-tooltip>
                      개선요청등록
                    </q-tooltip>
                  </q-btn>
                </q-btn-group>
              </div>
            </div>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </q-form>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'pre-startup-facility',
  props: {
    param: {
      type: Object,
      default: function() {
        return {
          sopPrestartupCheckId: '',
          isSearch: false,
        }
      }
    },
    preStartupCheck: {
      type: Object,
      default: function() {
        return {
          plantCd: null,
          sopPrestartupCheckId: '',
          equipments: [],
        }
      }
    },
    equipmentCd: {
      type: String,
      default: function() {
        return ''
      }
    },
  },
  data() {
    return {
      preStartupEquipment: {
        sopPrestartupCheckId: '',  // 가동전점검 일련 번호
        equipmentCd: '',  // 설비코드
        equipmentName: '',  // 설비명
        equipmentTypeCd: '',  // 설비 분류(상하위구조)
        equipmentTypeName: '',  // 설비 분류명(상하위구조)
        checkUserId: '',  // 점검 책임자
        checkScheduleDate: '',  // 점검 예정일
        checkDate: '',  // 점검일
        checkResultTotal: '',  // 점검 결과 종합
        checkCompleteFlag: 'N',  // 점검 완료 여부
        regUserId: '',  // 등록자 ID
        chgUserId: '',  // 수정자 ID
        checkTypes: [], // 점검유형
        checkItems: [], // 점검항목
        deleteCheckItems: [],
      },
      grid: {
        merge: [
          { index: 0, colName: 'psrCheckTypeName' },
          { index: 1, colName: 'level1' },
          { index: 2, colName: 'level2' },
        ],
        columns: [],
        data: [],
        height: '540px'
      },
      requestImprRow: null,
      imprData: null,
      editable: true,
      listUrl: '',
      completeUrl: '',
      isComplete: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '80%',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    editInfo() {
      return this.editable && !this.param.isSearch
    },
    disabled() {
      // 점검완료인 경우 비활성화
      return this.preStartupEquipment.checkCompleteFlag === 'Y' || this.preStartupCheck.psrCheckStatusCd === 'PCSC000005';
    },
    disabledItems() {
      let result = [];
      let disabledSteps = ['IS00000005', 'IS00000010', 'IS00000015', 'IS00000020']
      if (this.preStartupEquipment 
        && this.preStartupEquipment.checkItems 
        && this.preStartupEquipment.checkItems.length > 0) {
        this.$_.forEach(this.preStartupEquipment.checkItems, checkItem => {
          if (checkItem.improves && checkItem.improves.length > 0) {
            this.$_.forEach(checkItem.improves, improve => {
              if (this.$_.indexOf(disabledSteps, improve.ibmStepCd) > -1) {
                result.push(checkItem.psrCheckTypeCd);
                return false;
              }
            })
          }
        })
      }
      return result;
    },
    checkTypes() {
      return this.$_.map(this.preStartupEquipment.checkTypes, 'psrCheckTypeCd')
    }
  },
  watch: {
    'preStartupCheck': {
      handler: function () {
        this.preStartupEquipment = this.$_.find(this.preStartupCheck.equipments, { equipmentCd: this.equipmentCd });
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
      },
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.psr.check.checkTypeItemList.url
      this.completeUrl = transactionConfig.sop.psr.check.equipment.complete.url
      // code setting
      this.$comm.getComboItems('PSR_CHECK_PERIOD_CD').then(_result => {
        this.grid.columns = [
          {
            name: 'psrCheckTypeName', 
            field: 'psrCheckTypeName',
            label: '점검유형',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'checkItemName',
            field: 'checkItemName',
            label: '점검항목',
            sortable: false,
            child: [
              {
                name: 'level1',
                field: 'level1',
                label: '대분류',
                align: 'left',
                style: 'width:200px',
                sortable: false,
              },
              {
                name: 'level2',
                field: 'level2',
                label: '중분류',
                align: 'left',
                style: 'width:400px',
                sortable: false,
              },
              {
                name: 'level3',
                field: 'level3',
                label: '소분류',
                align: 'left',
                style: 'width:200px',
                sortable: false,
              },
            ]
          },
          {
            name: 'psrCheckPeriodCd',
            field: 'psrCheckPeriodCd',
            label: '점검시기',
            align: 'center',
            style: 'width:90px',
            sortable: false,
            type: 'select',
            comboItems: _result,
            setHeader: true,
          },
          {
            name: 'judgmentResultFlag',
            field: 'judgmentResultFlag',
            label: '적합여부',
            align: 'center',
            style: 'width:90px',
            sortable: false,
            type: 'select',
            comboItems: [
              { code: 'Y', codeName: '적합' },
              { code: 'N', codeName: '부적합' },
              { code: 'D', codeName: 'N/A' },
            ],
            setHeader: true,
          },
          {
            name: 'checkResult',
            field: 'checkResult',
            label: '점검결과',
            align: 'left',
            style: 'width:200px',
            sortable: false,
            type: 'text',
          },
          // {
          //   name: 'customCol',
          //   field: 'customCol',
          //   label: '개선번호 / 진행상태',
          //   align: 'center',
          //   style: 'width:150px',
          //   type: 'custom',
          //   sortable: false
          // },
          // {
          //   name: 'remark',
          //   field: 'remark',
          //   label: '비고',
          //   align: 'left',
          //   style: 'width:150px',
          //   sortable: false,
          //   type: 'text',
          // },
        ];
      });
      // list setting
      this.preStartupEquipment = this.$_.find(this.preStartupCheck.equipments, { equipmentCd: this.equipmentCd });
    },
    changeCheckType(val) {
      if (!val || val.length === 0) {
        this.$_.forEach(this.preStartupEquipment.checkItems, deleteItem => {
          if (this.$_.findIndex(this.preStartupEquipment.deleteCheckItems, { sopPrestartupCheckItemId: deleteItem.sopPrestartupCheckItemId }) === -1
            && deleteItem.editFlag !== 'C') {
            this.preStartupEquipment.deleteCheckItems.push(deleteItem)
          }
        })
        this.preStartupEquipment.checkItems = [];
      } else {
        this.$http.url = this.listUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.preStartupCheck.plantCd,
          checkTypes: this.$_.map(val, 'value')
        }
        this.$http.request((_result) => {
          if (_result.data && _result.data.length > 0) {
            if (this.preStartupEquipment.checkItems && this.preStartupEquipment.checkItems.length > 0) {
              this.$_.forEach(_result.data, item => {
                if (this.$_.findIndex(this.preStartupEquipment.checkItems, { sopPrestartupCheckItemId: item.sopPrestartupCheckItemId }) === -1) {
                  item.editFlag = 'C'
                  this.preStartupEquipment.checkItems.push(item);
                }
              })

              let deleteItems = [];
              this.$_.forEach(this.preStartupEquipment.checkItems, item => {
                if (this.$_.findIndex(_result.data, { sopPrestartupCheckItemId: item.sopPrestartupCheckItemId }) === -1) {
                  deleteItems.push(item);
                }
              })
              if (deleteItems && deleteItems.length > 0) {
                if (!this.preStartupEquipment.deleteCheckItems) this.preStartupEquipment.deleteCheckItems = [];
                this.$_.forEach(deleteItems, deleteItem => {
                  this.preStartupEquipment.checkItems = this.$_.reject(this.preStartupEquipment.checkItems, { sopPrestartupCheckItemId: deleteItem.sopPrestartupCheckItemId })

                  if (this.$_.findIndex(this.preStartupEquipment.deleteCheckItems, { sopPrestartupCheckItemId: deleteItem.sopPrestartupCheckItemId }) === -1
                    && deleteItem.editFlag !== 'C') {
                    this.preStartupEquipment.deleteCheckItems.push(deleteItem)
                  }
                })
              }
            } else {
              this.$_.forEach(_result.data, item => {
                item.editFlag = 'C'
              })
              this.preStartupEquipment.checkItems = _result.data;
            }
          } else {
            this.preStartupEquipment.checkItems = [];
          }
        },);
      }
    },
    // add() {
    //   let date = new Date();
    //   this.grid.data.push({
    //     id: String(date.getTime()),
    //     col0: '',
    //     level1: '',
    //     level2: '',
    //     level3: '',
    //     col2: '',
    //     col3: '',
    //     col4: '',
    //     col5: '', 
    //     col6: '', 
    //   });
    // },
    // remove() {
    //   let selectData = this.$refs['table'].selected;
    //   if (!selectData || selectData.length === 0) {
    //     window.getApp.$emit('ALERT', {
    //       title: '안내', // 안내
    //       message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
    //       type: 'warning', // success / info / warning / error
    //     });
    //   } else {
    //     this.$_.forEach(selectData, item => {
    //       this.grid.data = this.$_.reject(this.grid.data, { id: item.id })
    //     })
    //   }
    // },
    /* eslint-disable no-unused-vars */
    openImprove(props, col, item) {
      this.imprData = item;
      this.popupOptions.title = '개선';
      this.popupOptions.param = {
        isSearch: !this.editInfo || this.disabled,
        sopImprovementId: item.sopImprovementId,
        ibmTaskTypeCd: item.ibmTaskTypeCd,
        data: item,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      this.popupOptions.width = '90%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        this.$_.extend(this.imprData, result.col1)
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    innerBtnClicked(col, props, btn) {
      this.requestImprRow = props.row
      let requestContents = props.row.level1;
      if (props.row.level2) {
        requestContents += ' / ' + props.row.level2
      }
      if (props.row.level3) {
        requestContents += ' / ' + props.row.level3
      }
      this.popupOptions.title = '개선 요청';
      this.popupOptions.param = {
        requestContents: requestContents,
        relationTableKey: props.row.sopPrestartupEquipmentHasCheckItemId,
        ibmTaskTypeCd: 'ITT0000030',
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
      this.popupOptions.width = '90%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        if (!this.requestImprRow.improves) {
          this.requestImprRow.improves = [];
        }
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.requestImprRow.improves, { sopImprovementId: item.sopImprovementId }) === -1) {
            this.requestImprRow.improves.push(item);
          }
        })
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    completePreStartupEquipment() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '완료하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.preStartupEquipment.chgUserId = this.$store.getters.user.userId
              this.isComplete = !this.isComplete
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback(result) {
      this.preStartupEquipment.checkCompleteFlag = 'Y'
      window.getApp.$emit('APP_REQUEST_SUCCESS');
    },
  }
};
</script>